import { GameUI } from "game/gameUI/GameUI"
import { translate } from "game/translate"
import { Popups } from "ui/types/popups"

export const OutUndoPopup = () => {
    return (
        <div id="out-undo" role="tooltip" className="out_undo modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={() => GameUI.closePopup(Popups.OUT_UNDO_POPUP)}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("out_undo_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/magic_wand_modals/magic_wand_img_5.webp" />
                    <p className="modals_area-text">{translate("out_undo_text")}</p>
                    <button type="button" className="modals_area-btn" onClick={() => GameUI.closePopup(Popups.OUT_UNDO_POPUP, true)}>{translate("out_undo_btn")}</button>
                </div>
            </div>
        </div>
    )
}